import { useState } from "react";
import { History, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { istDate } from "@/components/DispatchDatePicker";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const date = "h-10 px-3 rounded-lg border border-[#E0DFD6] text-sm bg-white w-full";
const LBL = "text-[10px] font-semibold uppercase tracking-[0.16em] text-[#6B6B61]";

export const PhoneHistoryDialog = ({ open, onClose, onDone }) => {
  const [from, setFrom] = useState(istDate(7));
  const [to, setTo] = useState(istDate(0));
  const [busy, setBusy] = useState(false);
  const start = async () => {
    setBusy(true);
    try {
      await api.post("/sms/phone/history", { from_date: from, to_date: to });
      toast.success("Phone se purane SMS aa rahe hain — 2-5 min me Codes / Messages me dikhenge");
      onDone();
      onClose();
    } catch (e) {
      toast.error(formatApiError(e), { duration: 9000 });
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="sms-phone-history-dialog">
        <DialogHeader>
          <DialogTitle className="font-['Outfit'] flex items-center gap-2"><History className="w-5 h-5 text-[#385C4B]" /> Purane SMS phone se mangao</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-[#6B6B61]">Phone in dates ke saare SMS dobara bhejega. Jo pehle se save hain wo skip ho jayenge. Phone pe net chalu hona chahiye.</p>
        <div className="grid grid-cols-2 gap-3">
          <label className="space-y-1"><span className={LBL}>From date</span>
            <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className={date} data-testid="sms-phone-history-from" />
          </label>
          <label className="space-y-1"><span className={LBL}>To date</span>
            <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className={date} data-testid="sms-phone-history-to" />
          </label>
        </div>
        <p className="text-[11px] text-[#9A9A90]">Sirf wahi SMS aayenge jo abhi phone me hain. Har 30 min me pichhle 2 ghante ke SMS apne aap bhi check hote hain.</p>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="h-9 px-4 rounded-full border border-[#E0DFD6] text-sm" data-testid="sms-phone-history-cancel">Cancel</button>
          <button onClick={start} disabled={busy || !from} data-testid="sms-phone-history-start"
            className="h-9 px-5 rounded-full bg-[#385C4B] text-white text-sm font-semibold inline-flex items-center gap-1.5 disabled:opacity-50 transition-transform active:scale-95">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} SMS mangao
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
